import { TaskStatus } from 'app/console-api';

type TaskStatusConfig = {
  title: string;
  getColor(theme: any): string;
};

export const TasksStatusesMeta: Record<TaskStatus, TaskStatusConfig> = {
  [TaskStatus.NotStarted]: {
    title: 'Not Started',
    getColor: (theme: any) => theme.styleguideColors.contentWarmGreen
  },
  [TaskStatus.Inactive]: {
    title: 'Inactive',
    getColor: (theme: any) => theme.styleguideColors.contentTertiary
  },
  [TaskStatus.Active]: {
    title: 'Active',
    getColor: (theme: any) => theme.styleguideColors.contentGreen
  },
  [TaskStatus.Completed]: {
    title: 'Completed',
    getColor: (theme: any) => theme.styleguideColors.contentLightBlue
  }
};
